import React from 'react'
import { MdMailOutline, MdPhoneInTalk } from 'react-icons/md'
import styled from 'styled-components'
import polyglot from '../../Translator'

const Container = styled.div`
  text-align: center;
  color: #000;
  display: flex;
  margin: 120px 50px 200px;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
`

const LockContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;
  margin: 50px;
  @media screen and (max-width: 600px) {
    margin: 0px;
  }
`

const OopsNotAuthorized = styled.p`
  font-size: 18px;
`

const LockImage = styled.img``

const NotAuthorized = styled.div`
  max-width: 450px;
  margin: 50px;
  @media screen and (max-width: 600px) {
    margin: 50px 0px;
  }
`
const NotAuthParagraph = styled.p`
  font-size: 20px;
  margin: 40px 0px;
  text-align: left;
`

const Highlight = styled.span`
  color: #189f99;
  text-decoration: underline;
`

const notAuthorizedTranslations = {
  notAuthorizedSection: {
    en: 'Oops, it looks like you are not authorized to access this section.',
    fr: 'Oups, il semble que vous ne soyez pas autorisé à accéder à cette section.'
  },
  notAuthorizedDiagrams: {
    en: 'Your law firm has not been authorized to use the Org Charts application.',
    fr: 'Votre cabinet d’avocats n’a pas été autorisé à utiliser l’application Organigrammes.'
  },
  pleaseReachOut: {
    en: 'Please reach out to us to validate your billing information and and allow you again.',
    fr: 'Contactez-nous pour valider vos informations de facturation et vous autoriser à nouveau.'
  }
}

export default function LawFirmNotAuthorized() {
  return (
    <Container>
      <LockContainer>
        <OopsNotAuthorized>{polyglot.tr(notAuthorizedTranslations.notAuthorizedSection)}</OopsNotAuthorized>
        <LockImage src={require('./../../img/lock.svg')} alt="" />
      </LockContainer>
      <NotAuthorized>
        <NotAuthParagraph>{polyglot.tr(notAuthorizedTranslations.notAuthorizedDiagrams)}</NotAuthParagraph>
        <NotAuthParagraph>{polyglot.tr(notAuthorizedTranslations.pleaseReachOut)}</NotAuthParagraph>
        <NotAuthParagraph>
          <MdPhoneInTalk size={40} style={{ marginRight: '20px' }} />
          <Highlight>450-775-6257</Highlight>
        </NotAuthParagraph>
        <NotAuthParagraph>
          <MdMailOutline size={40} style={{ marginRight: '20px' }} />
          <a href="mailto:support@redox-technologies.ca?subject=Law Firm Activation">
            <Highlight>support@redox-technologies.ca</Highlight>
          </a>
        </NotAuthParagraph>
      </NotAuthorized>
    </Container>
  )
}
